import { ConfirmationDialog } from '../../shared/confirmation-dialog';
import { L } from 'harmony-language';
import React from 'react';
import { usePublishDraftsMutation } from '../../../api/mutations/reworked/use-publish-drafts-mutation';
import PropTypes from 'prop-types';

export const PublishDraftsModal = (props) => {
    const { open, records, unselectFn, onResultCallback } = props;
    const { mutate: publishDrafts } = usePublishDraftsMutation();

    return (
        <ConfirmationDialog
            open={open}
            title={L.publishConfirmationTitle()}
            message={L.publishConfirmationMessage(`${records.length} ${L.drafts().toLocaleLowerCase()}`)}
            cancelText={L.cancel()}
            confirmText={L.publish()}
            resultCallback={async (confirmed) => {
                onResultCallback();
                if (confirmed) {
                    unselectFn?.();
                    publishDrafts(records);
                }
            }}>
        </ConfirmationDialog>
    );
};

PublishDraftsModal.propTypes = {
    open: PropTypes.bool,
    records: PropTypes.array,
    unselectFn: PropTypes.func,
    onResultCallback: PropTypes.func
};
